'use client';

import { Button as BaseButton, Spinner, type ButtonProps } from '@cobrastyle/ui';
import { useTranslations } from 'next-intl';

// Same mapping as the library's own button.
const spinnerSizes = { sm: 'sm', md: 'sm', lg: 'md' } as const;

/**
 * @cobrastyle/ui's Button hard-codes the English "Loading..." while `isLoading`.
 * This wrapper renders the library's loading look (spinner, disabled) but with
 * the translated text. Without `isLoading` it is the library button unchanged.
 */
export function Button({ isLoading = false, children, size = 'md', ...props }: ButtonProps) {
  const t = useTranslations('common');

  if (!isLoading) {
    return (
      <BaseButton size={size} {...props}>
        {children}
      </BaseButton>
    );
  }

  return (
    <BaseButton size={size} {...props} isLoading={false} disabled aria-busy="true">
      <Spinner size={spinnerSizes[size]} />
      {t('loading')}
    </BaseButton>
  );
}
